import "./restaurant.css";
import React, { useState, useCallback } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import { PiUserCheck } from "react-icons/pi";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import ButtonCom from "../../components/button/button";

const UserManagement = () => {
  const [roleList, setRoleList] = useState([
    { roleId: "1", roleName: "Developer" },
    { roleId: "2", roleName: "Designer" },
  ]);
  const [userList, setUserList] = useState([
    { id: "1", userName: "Kunal", userRole: "1" },
    { id: "2", userName: "G Manikam", userRole: "2" },
  ]);
  const [filterUserList, setFilterUserList] = useState([
    { id: "1", userName: "Kunal", userRole: "1" },
    { id: "2", userName: "G Manikam", userRole: "2" },
  ]);
  const [show, setShow] = useState(false);
  const [shiftId, setShiftId] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const isSelectAll =
    selectedUsers.length === userList.length && userList.length > 0;

  const heading = [
    {
      headerName: "Employee",
      flex: 1,
      cellRenderer: (rowData) => {
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "7px" }}>
            <h3>{rowData.data.userName}</h3>
            <span className="user-role">
              ({" "}
              {roleList.map((v) => {
                return v.roleId == rowData.data.userRole ? v.roleName : null;
              })}{" "}
              )
            </span>
          </div>
        );
      },
    },

    {
      headerName: "Action",
      width: 300,
      cellRenderer: (rowData) => {
        return (
          <>
            <div className="Branches-table-button rest-icon-top">
              <PiUserCheck
                style={{
                  cursor: "pointer",
                  fontSize: 25,
                  marginRight: "10px",
                }}
                className="assign-icon"
                onClick={() => {
                  handleShow();
                  handleAssignId(rowData.data.shiftId);
                }}
              />
              <select className="user-role-dropdown">
                {roleList.map((v) => {
                  return (
                    <option selected={v.roleId == rowData.data.userRole}>
                      {v.roleName}
                    </option>
                  );
                })}
              </select>
            </div>
          </>
        );
      },
    },
  ];
  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];

  const handleShow = () => setShow(true);

  const getEmployeeList = useCallback((id) => {}, []);

  const handleAssignId = (id) => {
    setShiftId(id);
    getEmployeeList(id);
  };

  const handleModalClose = () => {
    setShow(false);
    setSelectedUsers([]);
  };

  const searchEmployees = (val) => {
    setSearchQuery(val);
    const filteredUsers = filterUserList.filter((v) =>
      v.full_name.toLowerCase().includes(val.toLowerCase())
    );
    setUserList(filteredUsers);
  };

  const SelectAll = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allUserIds = userList.map((row) => row.staffId);
      setSelectedUsers(allUserIds);
    } else {
      setSelectedUsers([]);
    }
  };

  const selectUser = (event, userId) => {
    let isNotSelectedAll = false;
    const isChecked = event.target.checked;
    setSelectedUsers((prevSelected) =>
      isChecked
        ? [...prevSelected, userId]
        : prevSelected.filter((id) => id !== userId)
    );
    let elem = document.querySelectorAll(".colored-checkbox");
    const nodeArray = [...elem];
    nodeArray?.map((v, idx) => {
      if (idx != 0) {
        // if (v.checked == false) {
        //   isNotSelectedAll = true;
        // }
      }
    });
  };

  const handleAssignShiftSubmit = (e) => {
    e.preventDefault();
    const data = {};
  };

  return (
    <div>
      <div className="SettingBody-head">
        <Link to={"/audit"}>
          <ArrowBackIcon sx={{ scale: 1 }} />
        </Link>
        <p>User Management</p>
      </div>

      <div className="user-management-body">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            marginBottom: "10px",
          }}
        >
          <ButtonCom
            ButtonCom
            type={"button"}
            class_name={"p_btn"}
            text={"Create"}
            ext
            url_or_onclick={null}
            icon={null}
            width={""}
          />
        </div>
        <div className="ag-theme-quartz" style={{ height: 550, width: "100%" }}>
          <AgGridReact
            rowData={Array.isArray(userList) ? userList : []}
            columnDefs={heading}
            omLayout="autoHeight"
            pagination={true}
            paginationPageSize={paginationPageSize}
            paginationPageSizeSelector={paginationPageSizeSelector}
          />
        </div>
      </div>

      <Modal show={show} onHide={handleModalClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Assign Employee to </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
          <input
            className="search-employee"
            type="text"
            placeholder="Search employees..."
            value={searchQuery}
            onChange={(e) => searchEmployees(e.target.value)}
          />
          <table className="audit-tbl">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    checked={isSelectAll}
                    onChange={SelectAll}
                    id="sel-all"
                    className="colored-checkbox"
                  />
                  &nbsp; &nbsp;
                  <label style={{ cursor: "pointer" }} htmlFor="sel-all">
                    Select All
                  </label>
                </th>
                <th>Employee Name</th>
              </tr>
            </thead>
            <tbody>
              {/* {userList.length > 0 ? (
                userList.map((row) => (
                  <tr key={row.staffId}>
                    <td>
                      <input
                        type="checkbox"
                        checked={
                          row.shiftAssignedStatus == "1" ||
                          selectedUsers.includes(row.staffId)
                        }
                        onChange={(e) => selectUser(e, row.staffId)}
                        id={"shift" + row.staffId}
                        className="colored-checkbox"
                      />
                    </td>
                    <td
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor={"shift" + row.staffId}
                      >
                        {row.full_name}
                      </label>
                      <span style={{ fontSize: "12px", color: "gray" }}>
                        {row.employee_id}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2">No employees found</td>
                </tr>
              )} */}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "#566573",
              color: "#fff",
              marginRight: "5px",
              border: "none",
            }}
            onClick={handleModalClose}
          >
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: "#5dade2",
              color: "#fff",
              border: "none",
            }}
            onClick={handleAssignShiftSubmit}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UserManagement;
